import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { DataGrid } from "../../components";
import { DataGridButtonProps } from "../../components/data-grid/types";
import { getLocalized } from "../../redux/localization";
import { productUrl } from "../../services/urls";

const ProductPage = () => {
  const localize = useSelector(getLocalized);
  const history = useHistory();
  const columns = [
    {
      dataField: "Code",
      caption: localize.getString("code"),
    },
    {
      dataField: "Name",
      caption: localize.getString("name"),
    },
    {
      dataField: "ProductTypeName",
      caption: localize.getString("producttypename"),
    },
    {
      dataField: "StatusMessage",
      caption: "Durum",
    },
    {
      dataField: "ApproverUser",
      caption: localize.getString("approveruser"),
    },
  ];
  const buttons: DataGridButtonProps[] = [
    {
      hint: "info",
      icon: "info",
      onClick: function (e: any) {
        history.push(`/product-details/${e.row.data.Id}`);
      },
    },
  ];

  return (
    <DataGrid
      buttons={buttons}
      getByIdUrl={productUrl}
      url={productUrl}
      columns={columns || []}
      refObject={{}}
      title="Ürünler"
      // details={{
      //   width: "35%",
      //   height: "62%",
      //   getByIdUrl: "api/AppUser",
      //   title: "Kullanıcı Detayları",
      //   component: DetailUserForm,
      // }}
      // edit={{
      //   width: "35%",
      //   height: "62%",
      //   editUrl: userUrl,
      //   title: "Kullanıcı Düzenle",
      //   component: EditUserForm,
      //   validationGroup: "editUserFormValidation",
      // }}
      // create={{
      //   lookup: {
      //     lookupUrl: departmanUrl,
      //   },
      //   width: "35%",
      //   height: "62%",
      //   createUrl: createUserUrl,
      //   title: "Kullanıcı Ekle",
      //   component: CreateUserForm,
      //   validationGroup: "createUserFormValidation",
      // }}
      //   remove={{ url: modelUrl }}
    />
  );
};
export default ProductPage;
